import Form from "../../form/Form";
import Cart from "./Cart";
import { notice } from "JS/utils/notice";

export default class CouponForm {
    /**
     * @type {Form}
     */
    form;

    /**
     * @type {Cart}
     */
    cart;

    /**
     * @type {HTMLElement}
     */
    parent;

    _writeOff = true;

    get writeOff() {
        return this._writeOff;
    }

    /**
     * 
     * @param {Cart} cart
     */
    constructor(cart) {
        this.cart = cart;
        this.init();
    }

    init() {
        const form = document.querySelector('.cart-payment__promo');
        if (!form) {
            return;
        }

        this.form = new Form(form);
        this.parent = this.form.formElement.closest('.cart-payment');
        this.btnSubmit = this.form.formElement.querySelector('[data-apply-coupon]');

        this.addValidations();
        this.addListeners();

        if (this.parent) {
            setTimeout(() => {
                this.parent.classList.remove('loading');
            }, 100);
        }
    }

    addValidations() {
        const input = this.form.fields.find(el => el.name === 'coupon_code');

        if (!input) {
            return;
        }

        input.validations.push('coupon_code');
    }

    addListeners() {
        this.form.on('submit', (data) => {
            this.onSubmit(data);
        });

        Array.from(this.form.formElement.querySelectorAll('.woocommerce-remove-coupon')).forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const code = el.dataset.coupon;
                this.removeCoupon(code);
            });
        });
    }

    removeCoupon(code) {
        if (!code) {
            return;
        }
        const data = this.form.collectValues();
        data.coupon_code = code;
        data.remove = true;

        this.onSubmit(data);
    }

    onSubmit(data) {
        if (this.parent) {
            this.parent.classList.add('loading');
        }

        const formData = new FormData();
        formData.append('action', 'apply_coupon');
        formData.append('data', JSON.stringify(data));
        this.btnSubmit.classList.add('processing');
        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((resp) => resp.json())
            .then((response) => {
                if (!response.success) {
                    this.onError(response.data);
                    return;
                }

                const {
                    html,
                    message,
                    done,
                } = response.data;

                if (done) {
                    notice(message);
                } else {
                    this.onError(message);
                }
                if (html) {
                    this.replaceCartProcess(html);
                }
            })
            .catch((error) => {
                this.onError(error);
            })
            .finally(() => {
                const input = this.form.fields.find(el => el.name === 'coupon_code');
                this.btnSubmit.classList.remove('processing');

                if (input) {
                    input.reset();
                }

                if (this.parent) {
                    this.parent.classList.remove('loading');
                }
            });
    }

    onError(error) {
        notice(error, 'error');
    }

    replaceCartProcess(html) {
        const wrap = document.createElement('div');
        wrap.innerHTML = html;

        const cartProcess = wrap.querySelector('.cart-payment');

        cartProcess.classList.add('loading');
        
        this.parent.replaceWith(cartProcess);

        this.init();
        this.cart.usePoints.init();
    }
}
